import type { CloneAppResponse } from './api'

export interface CloneNotice {
  tone: 'info' | 'warning'
  message: string
}

export function getCloneNotice(response: CloneAppResponse): CloneNotice {
  if (response.secret_copy_status === 'failed') {
    return {
      tone: 'warning',
      message: 'App cloned, but secret values could not be copied. Review the Secrets section before starting it.',
    }
  }

  if (!response.is_own_clone) {
    return {
      tone: 'warning',
      message: 'App cloned. Secret values were intentionally not copied from the source app. Add them in the Secrets section before starting it.',
    }
  }

  return {
    tone: 'info',
    message: 'App cloned. Any existing secret values were copied to the new app.',
  }
}
